/** The welcome's standard look (signed-in-home.html Band 4): the label, or the welcome on its own with nothing booked. */
import { partsOf, pieceRoot } from '../../contract/runtime';
import account from '../../styles/account.module.css';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import { onLink } from '../../ui/onLink';
import css from './HomeWelcome.module.css';
import type { HomeWelcomeRuntime } from './useHomeWelcome';
import { contract } from './contract';

const part = partsOf(contract);

export function HomeWelcomeView({ state, actions }: HomeWelcomeRuntime) {
  if (state.status !== 'ready') return null;
  if (state.hasNext) {
    return (
      <div className={account.label} {...pieceRoot(contract)}>
        <div className={account.eyebrow} {...part('label')}>
          <span>
            Welcome back, <em {...part('name')}>{state.firstName}</em> · Your next session
          </span>
        </div>
      </div>
    );
  }
  return (
    <>
      {/* Two roots side by side, so each carries the piece's name. */}
      <div className={account.label} {...pieceRoot(contract)}>
        <div className={account.eyebrow} {...part('label')}>
          Welcome back
        </div>
      </div>
      <div className={css.empty} {...pieceRoot(contract)} {...part('empty')}>
        <div>
          <h2 className={css.title}>
            Welcome back, <span className={css.name} {...part('name')}>{state.firstName}</span>
          </h2>
          <p className={css.line}>Nothing on the calendar yet.</p>
          {state.lastSession && (
            <p className={`${account.quiet} ${css.last}`} {...part('lastSession')}>
              {state.lastSession}
            </p>
          )}
        </div>
        <div className={css.ctas}>
          <a className={`${shared.btn} ${shared.btnPrimary} ${css.book}`} href={state.bookHref} onClick={onLink(() => actions.open(state.bookHref))} {...part('book')}>
            Book a session
            <Icon name="arrow" />
          </a>
          {state.bookAgain && (
            <a
              className={`${shared.btn} ${shared.btnOutline} ${css.book}`}
              href={state.bookAgain.href}
              onClick={onLink(() => actions.open(state.bookAgain!.href))}
              {...part('bookAgain')}
            >
              {state.bookAgain.label}
            </a>
          )}
        </div>
      </div>
    </>
  );
}
